<template>
  <highcharts :options="chartOptions"></highcharts>
</template>
<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
export default {
  name: 'ColumnChart',
  data () {
    return {
      chartData: {
        categories: [],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['currentReportMailbox', 'reportDates']),
    chartOptions: function () {
      return {
        chart: {
          type: 'column',
          plotBorderWidth: 1
        },
        legend: {
          enabled: false
        },
        title: {
          text: ''
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        xAxis: {
          type: 'datetime',
          categories: this.chartData.categories.map((data) => { return moment(data).format('MMM D') }),
          labels: {
            step: 3
          }
        },
        series: [{
          type: 'column',
          name: 'New Conversations',
          data: this.chartData.data
        }]
      }
    }
  },

  methods: {
    getChartData () {
      if (!this.currentReportMailbox.id) {
        return false
      }
      var vm = this
      this.$http.get('/volume_chart_data', {params: {mailbox: this.currentReportMailbox.id, start_date: this.reportDates.startDate, end_date: this.reportDates.endDate}})
        .then(function (response) {
          vm.chartData.categories = response.data.map(item => item.date)
          vm.chartData.data = response.data.map(item => item.emails)
        })
        .catch(e => { console.log(e.response) })
    }
  },
  watch: {
    currentReportMailbox () {
      this.getChartData()
    },
    reportDates () {
      this.getChartData()
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/reports/ColumnChart.vue